<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title">Contents</h1>
<h2 class="toc"><a href="#/xhtml/05_Acknowledgements"><em class="italic">Acknowledgements</em></a></h2>
<h2 class="toc"><a href="#/xhtml/06_Abbreviations"><em class="italic">Abbreviations</em></a></h2>
<h2 class="toc1t"><a href="#/xhtml/07_Chapter01"><span class="bold">Chapter 1</span><span class="space">The King and the Sweat</span></a></h2>
<h2 class="toc1t"><a href="#/xhtml/08_Chapter02"><span class="bold">Chapter 2</span><span class="space">Plague and Pestilence</span></a></h2>
<h2 class="toc1t"><span href="#/xhtml/09_Chapter03" title="Link target outside of Sample"><span class="bold">Chapter 3</span><span class="space">Environments</span></span></h2>
<h2 class="toc1t"><span href="#/xhtml/10_Chapter04" title="Link target outside of Sample"><span class="bold">Chapter 4</span><span class="space">The Sweat in Henry VII’s Reign</span></span></h2>
<h2 class="toc1t"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample"><span class="bold">Chapter 5</span><span class="space">A Sickly Decade</span></span></h2>
<h2 class="toc1t"><span href="#/xhtml/12_Chapter06" title="Link target outside of Sample"><span class="bold">Chapter 6</span><span class="space">The Outbreaks of 1528 and 1529</span></span></h2>
<h2 class="toc1t"><span href="#/xhtml/13_Chapter07" title="Link target outside of Sample"><span class="bold">Chapter 7</span><span class="space">The Final Epidemic</span></span></h2>
<h2 class="toc1t"><span href="#/xhtml/14_Chapter08" title="Link target outside of Sample"><span class="bold">Chapter 8</span><span class="space">Recollections</span></span></h2>
<h2 class="toc1"><span href="#/xhtml/15_Appendix01" title="Link target outside of Sample"><em class="italic">Appendix 1: The Household Orders of 1539</em></span></h2>
<h2 class="toc"><span href="#/xhtml/16_Appendix02" title="Link target outside of Sample"><em class="italic">Appendix 2: The Sweating Sickness in Holinshed’s</em> Chronicles</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Notes" title="Link target outside of Sample"><em class="italic">Notes</em></span></h2>
<h2 class="toc"><span href="#/xhtml/18_Bibliography" title="Link target outside of Sample"><em class="italic">Bibliography</em></span></h2>
<h2 class="toc"><span href="#/xhtml/19_Plates" title="Link target outside of Sample"><em class="italic">Plates</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?f5c6a3dc